import type { ProfileFormData } from '@/components/profile/tabs/form/ProfileForm';

export function mapProfileToFormDefaults(profile: any): ProfileFormData {
  let month = '';
  let day = '';
  let year = '';

  if (profile?.date_of_birth) {
    const date = new Date(profile.date_of_birth);
    month = String(date.getMonth() + 1).padStart(2, '0');
    day = String(date.getDate()).padStart(2, '0');
    year = String(date.getFullYear());
  }

  return {
    title: profile?.title || '',
    firstName: profile?.first_name || '',
    middleName: profile?.middle_name || '',
    lastName: profile?.last_name || '',
    dateOfBirthMonth: month,
    dateOfBirthDay: day,
    dateOfBirthYear: year,
    streetNumber: profile?.street_number || '',
    streetName: profile?.street_name || '',
    suiteAptUnit: profile?.suite_apt_unit || '',
    city: profile?.city || '',
    provinceState: profile?.province_state || '',
    postalCode: profile?.postal_code || '',
    country: profile?.country || 'Canada',
    phoneNumber: profile?.phone_number || '',
    citizenship: profile?.citizenship || 'Canada',
    isAccredited: !!profile?.is_accredited,
    defaultCurrency: (profile?.default_currency || 'CAD').toUpperCase(),
    linkedinProfile: profile?.linkedin_profile || '',
    professionalDesignations: Array.isArray(profile?.professional_designations) ? profile.professional_designations : [],
  };
}

export function buildProfileUpdate(values: ProfileFormData) {
  let dateOfBirth: string | null = null;
  if (values.dateOfBirthYear && values.dateOfBirthMonth && values.dateOfBirthDay) {
    dateOfBirth = `${values.dateOfBirthYear}-${values.dateOfBirthMonth}-${values.dateOfBirthDay}`;
  }

  return {
    first_name: values.firstName,
    last_name: values.lastName,
    is_accredited: values.isAccredited,
    ...(values.title && { title: values.title }),
    ...(values.middleName && { middle_name: values.middleName }),
    ...(dateOfBirth && { date_of_birth: dateOfBirth }),
    ...(values.streetNumber && { street_number: values.streetNumber }),
    ...(values.streetName && { street_name: values.streetName }),
    ...(values.suiteAptUnit && { suite_apt_unit: values.suiteAptUnit }),
    ...(values.city && { city: values.city }),
    ...(values.provinceState && { province_state: values.provinceState }),
    ...(values.postalCode && { postal_code: values.postalCode }),
    ...(values.country && { country: values.country }),
    ...(values.phoneNumber && { phone_number: values.phoneNumber }),
    ...(values.citizenship && { citizenship: values.citizenship }),
    ...(values.defaultCurrency && { default_currency: values.defaultCurrency.toUpperCase() }),
    ...(values.linkedinProfile && { linkedin_profile: values.linkedinProfile }),
    professional_designations: values.professionalDesignations || [],
  } as const;
}
